import React from "react";
import { useParams } from "@tanstack/react-router";

export const DoctorLoginView: React.FC = () => {
  // Get the splat parameter from the route
  const { $ = "" } = useParams({ from: "/doctor/$" });

  
  const baseUrl = process.env.REACT_APP_DOCTOR_BASE_URL;


  const externalUrl = `${baseUrl}/${$}`;
  console.log("External URL:", externalUrl); // Debugging line to check the URL
  return (
    <iframe
      src={externalUrl}
      style={{
        width: "100%",
        height: "100vh",
        border: "none",
        display: "block", // Ensures proper rendering
      }}
      title="Doctor Portal"
      allow="*" // Allow all features
      sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads" // Allow necessary interactions
    />
  );
};
